import { useMemo } from 'react'
import { buildChallengeContext, type ChallengeContext } from './challengeContext'
import { useChallenge } from './useChallenge'
import { useChallengeBuckets } from './useChallengeBuckets'
import { useChallengeId } from './useChallengeId'

export function useChallengeContext(challengeId?: string): {
  data: ChallengeContext | undefined
  isLoading: boolean
  error: Error | null
} {
  const activeChallengeId = useChallengeId()
  const resolvedChallengeId = challengeId || activeChallengeId
  const {
    data: challenge,
    isLoading: challengeLoading,
    error: challengeError,
  } = useChallenge(resolvedChallengeId)
  const {
    data: buckets,
    isLoading: bucketsLoading,
    error: bucketsError,
  } = useChallengeBuckets(resolvedChallengeId)

  const data = useMemo(() => {
    if (!challenge || !buckets?.length) return undefined
    return buildChallengeContext(challenge, buckets)
  }, [challenge, buckets])

  return {
    data,
    isLoading: challengeLoading || bucketsLoading,
    error: (challengeError ?? bucketsError) as Error | null,
  }
}
